import React, {useEffect, useState} from "react";
import copy from "copy-to-clipboard";
import {useTranslation} from "next-i18next";
import {Tooltip} from "antd";
import {DelayedHookState} from "@/base/types/delayed-effect.hook";

type Props = {
	copyText: any | (() => any)
	children: React.ReactNode | null
	className?: string
	rootClassName?: string
	onClick?: React.MouseEventHandler<HTMLDivElement>
	tooltip?: boolean
}

export default function CopyToClipboard({
	children = null,
	className = '',
	copyText = '',
	rootClassName = '',
	onClick = () => null,
	tooltip = true
}: Props) {
	const {t} = useTranslation()

	const [copied, setCopied] = useState<boolean>(false)

	const handleClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
		copy(typeof copyText !== "function" ? copyText : copyText())

		setCopied(true)
		onClick(e)
	}

	const cTimeout = DelayedHookState(2000);

	useEffect(() => {
		if (copied)
		{
			cTimeout.call(() => {
				setCopied(false)
			});
		}
	}, [copied])

	return <div className={`${!copied && `cursor-pointer`} relative ${rootClassName || ''}`} onClick={handleClick}>
		<Tooltip title={tooltip ? t(`base-common:copy.copy-on-click`) : ""} mouseLeaveDelay={0} className={className}>
			{children}
		</Tooltip>
		{copied && <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full backdrop-blur-sm z-50`}>
			<div className={`absolute top-1/2 left-1/2 -translate-x-1/2 cursor-default -translate-y-1/2 bg-gradient-to-r from-primary-100 to-main-bg px-3 rounded-lg shadow-lg rounded-l-none border-0 border-l-2 border-solid border-primary`}>
				{t('base-common:copy.copied')}
			</div>
		</div>}
	</div>
}